module.exports = __webpack_public_path__ + "static/front-end-62754a97bd86f1f7d5869a8fde33471a.svg";